/*
 * @Author: Vanny
 * @Date: 2018-09-13 14:37:20
 * @LastEditors: Vanny
 * @LastEditTime: 2019-11-13 19:51:20
 * @Description: 帮助中心的路由
 */
import Vue from 'vue'
import 'babel-polyfill'

import GmToast from '@/components/Toast'
import i18n from '@/utils/i18n'
import '@/utils/axios'
import store from './store'
import router from './router'
import HelpCenter from './HelpCenter'
import Sentry from '../sentry'
import '../../style/font.css'

Vue.use(GmToast)
Vue.use(Sentry, { category: 'help-center', email: 'ruoyingyun@gmail.com' })

const app = new Vue({
  i18n,
  store,
  router,
  template: '<HelpCenter />',
  components: { HelpCenter },
})

app.$mount('#app')



// WEBPACK FOOTER //
// ./src/views/help-center/main.js